module.exports = __webpack_public_path__ + "img/red_berries.d64b753a.jpg";